<template>
<div class="flex md:w-full lg:w-auto">
  <div class="h-4/5 z-0 container absolute ml-10 md:mt-10 mt-6
  invisible lg:visible">
  </div>
  <div class="flex flex-col flex-wrap justify-center md:flex-row w-screen md:w-full
   py-10 bg-white z-10 lg:px-20 md:px-10
    box-shadow-3d blur relative overscroll-auto h-full mt-20">
      <teacher-card class="md:block hidden"
      v-for="teacher in filteredTeachers" :key="teacher.id"
      :teacher="teacher"
    />
      <teacher-card-mobile class="block md:hidden"
      v-for="teacher in filteredTeachers" :key="'mobile_'+teacher.id"
      :teacher="teacher"
    />
  </div>
</div>
</template>

<script>
import TeacherCard from '@/components/teachers/TeacherCard.vue';
import { mapGetters } from 'vuex';
import { getTeachers } from '@/services/TeacherService';
import TeacherCardMobile from './TeacherCardMobile.vue';

export default {
  data() {
    return {
      teachers: [],
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),

    filteredTeachers() {
      if (this.teachers.length > 0) {
        return this.teachers.filter(
          (teacher) => (!this.authenticated || teacher.user_id !== this.user.id),
        );
      }
      return true;
    },
  },

  components: {
    TeacherCard,
    TeacherCardMobile,
  },

  mounted() {
    this.loadTeachersList();
  },

  methods: {
    loadTeachersList() {
      getTeachers().then((response) => {
        this.teachers = response.data.sort(
          (teacher1, teacher2) => teacher2.stars_avg - teacher1.stars_avg,
        );
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

  },

};
</script>

<style lang="scss" scoped>
  .blur{
    background: rgb(255, 255, 255, 0.8);
    box-shadow: 0 3px 20px 0 rgba(92, 92, 92, 0.842);
    backdrop-filter: blur( 3.0px );
    -webkit-backdrop-filter: blur( 3.0px );
  }
/*   .box-3d {
    padding: 10px;
    margin: 10px 5px 20px;
    border-top: 1px solid #f4f4f2;
    -ms-box-shadow: 0 7px 0 #BFBAAD, 0 0.5em 0 #A8A38C, 0 12px 12px #A8A38C;
    -moz-box-shadow: 0 7px 0 #BFBAAD, 0 0.5em 0 #A8A38C, 0 12px 12px #A8A38C;
    -o-box-shadow: 0 7px 0 #BFBAAD, 0 0.5em 0 #A8A38C, 0 12px 12px #A8A38C;
    -webkit-box-shadow: 0 7px 0 #BFBAAD, 0 0.5em 0 #A8A38C, 0 12px 12px #A8A38C;
    box-shadow: 0 7px 0 #BFBAAD, 0 0.5em 0 #A8A38C, 0 12px 12px #A8A38C;
    -ms-border-radius: 8px;
    -moz-border-radius: 8px;
    -o-border-radius: 8px;
    -webkit-border-radius: 8px;
    border-radius: 8px;
  } */
  .box-shadow-3d{
    box-shadow: 1px 1px 0px #999,
                2px 2px 0px #999,
                3px 3px 0px #999,
                4px 4px 0px #999,
                5px 5px 0px #999,
                6px 6px 0px #999;
  }
</style>
